export function calculatePayment(income, paymentPercent, creditPayments, limitPercent, lifeCost, livingWage) {
    const firstOption = income * paymentPercent - creditPayments - limitPercent;
    const secondOption = income - lifeCost - creditPayments - limitPercent - livingWage;
    return Math.min(firstOption, secondOption);
}
